
// let baseURL = process.env.NODE_ENV === 'production' ? 'https://mj.zlygu.com/api/' : 'https://mj.zlygu.com/api/'
let baseURL = process.env.NODE_ENV === 'production' ? '/api/' : '/api/'
export default {
    baseURL,
    timeout: 5000
}